import type { AgentMode } from '@/index'
import type { FormattedAgentActivity, FormattedUserActivity } from '@/features/events/shared'
import { createEmptyClaudeSessionMemory, type ClaudeSessionMemory } from './ClaudeSessionMemory'

export interface ClaudeSessionRuntime {
  memory: ClaudeSessionMemory
  pendingAgentMode: AgentMode | null
  agentActivity: FormattedAgentActivity | null
  userActivity: FormattedUserActivity | null
  latestActivity: FormattedAgentActivity | FormattedUserActivity | null
}

export function createClaudeSessionRuntime(): ClaudeSessionRuntime {
  return {
    memory: createEmptyClaudeSessionMemory(),
    pendingAgentMode: null,
    agentActivity: null,
    userActivity: null,
    latestActivity: null,
  }
}
